import { Flex, Form, TextField } from '@approvalmax/ui/src/components';
import { memo, useMemo } from 'react';

import { FieldSelect } from '../FieldSelect/FieldSelect';
import { inputFieldTypes, selectFieldTypes } from './Fields.constants';
import { messages } from './Fields.messages';
import { FieldsProps } from './Fields.types';

export const Fields = memo<FieldsProps>((props) => {
    const { fields } = props;

    const filteredFields = useMemo(() => {
        return fields?.filter((field) => field.enabled) || [];
    }, [fields]);

    return (
        <Form.Part>
            <Flex container width='100%'>
                {filteredFields.map((field) => (
                    <Flex key={field.path} size={12} grow={1} block>
                        {inputFieldTypes.includes(field.field.type) && (
                            <TextField
                                name={field.path}
                                placeholder={messages.inputFieldPlaceholder}
                                label={field.field.label}
                                hint={field.field.description}
                                required={field.required}
                            />
                        )}

                        {selectFieldTypes.includes(field.field.type) && (
                            <FieldSelect field={field} placeholder={messages.selectFieldPlaceholder} />
                        )}
                    </Flex>
                ))}
            </Flex>
        </Form.Part>
    );
});

Fields.displayName = 'Fields';
